import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import BotService from "../../../../../services/BotService/BotService"
import SelectInput from "../../../../../components/SelectInput/SelectInput";
import RichTextEditor from "react-rte";
import { useSetRecoilState } from 'recoil';
import { alertState } from '../../../../../recoil-store/recoil-state';

const StepSelectPublishType = ({ publishDetail, setIsRequired, setPublishDetail, checkAndSetVariables }) => {
    // Assign initial values to hooks

    const { t } = useTranslation();
    const [bots, setBots] = useState([]);
    const [publishType, setPublishType] = useState(publishDetail.publish_detail.publish_type ? publishDetail.publish_detail.publish_type : '');
    const [selectedBotId, setSelectedBotId] = useState(publishDetail.publish_detail.bot_id ? publishDetail.publish_detail.bot_id : "");
    const setAlert = useSetRecoilState(alertState);

    useEffect(() => {
        if (publishType === 'new') {
            setIsRequired(false);
        } else if (publishType === 'update') {
            setIsRequired(selectedBotId.length > 0 ? false : true);
            const fetchData = async () => {
                const { data } = await BotService.getBotListByVendor();
                if (Array.isArray(data)) {
                    setBots(data);
                } else {
                    setBots([]);
                }
            }
            fetchData().then(r => r);
        } else {
            setIsRequired(true);
        }

    }, [publishType])

    // Handle checkbox values changes
    const handleChange = (e) => {
        setPublishType(e.target.name);
        if (e.target.name === 'new') {
            setSelectedBotId('');
            setPublishDetail(oldState => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    publish_type: e.target.name,
                    bot_id: '',
                    name: '',
                    tags: '',
                    automation_types_id: '',
                    security_stage_id: '',
                    description: '',
                    short_description: '',
                    benefit: '',
                    support: '',
                    configuration: '',
                    guide: '',
                    applications: [],
                    business_process_id: [],
                    categories: [],
                    images: []
                }
            }))
        } else {
            setPublishDetail(oldState => ({
                publish_detail: {
                    ...oldState.publish_detail,
                    publish_type: e.target.name,
                }
            }))
        }
    }

    const updateBotDetail = (bot, value) => {
        let applications = [];
        let business_processes = [];
        let categories = [];
        let images = [];
        if (value.applications && value.applications.length) {
            applications = value.applications.map(item => {
                return { id: item.id, type: item.bot_applications.type }
            })
        }

        if (value.business_processes && value.business_processes.length) {
            business_processes = value.business_processes.map(item => item.id)
        }

        if (value.categories && value.categories.length) {
            categories = value.categories.map(item => item.id)
        }

        if (value.bot_images && value.bot_images.length) {
            images = value.bot_images.map(item => item.thumbnail)
        }

        setPublishDetail(oldState => ({
            publish_detail: {
                ...oldState.publish_detail,
                bot_id: bot.id,
                name: value.name,
                tags: value.tags,
                automation_types_id: value.automation_types_id,
                security_stage_id: value.security_stage_id,
                description: RichTextEditor.createValueFromString(value.bot_details[0].description, "html"),
                short_description: RichTextEditor.createValueFromString(value.bot_details[0].short_description, "html"),
                benefit: RichTextEditor.createValueFromString(value.bot_details[0].benefit, "html"),
                support: value.bot_details[0].support,
                configuration: RichTextEditor.createValueFromString(value.bot_details[0].configuration, "html"),
                guide: RichTextEditor.createValueFromString(value.bot_details[0].guide, "html"),
                applications: applications,
                business_process_id: business_processes,
                categories,
                images,
                latest_version: bot.latest_version
            }
        }))
        checkAndSetVariables(value.bot_versions[0].flow_detail.variables);
    }

    const handleSelect = async ({ target: { value } }) => {
        if (value !== '') {
            const bot = bots.find(x => x.id === value);
            if (bot) {
                const response = await BotService.getBotDetailForPublish(bot.id, bot.latest_version);
                if (response && response.status && response.data) {
                    setSelectedBotId(value);
                    updateBotDetail(bot, response.data);
                    setIsRequired(false);
                    return
                } else {
                    setAlert(alert => ({ ...alert, show: true, message: t('MESSAGES.PUBLISH.' + response.message), severity: 'error' }))
                }
            }
        } else {
            setSelectedBotId('');
        }
        setIsRequired(true);
    }

    return (
        <div style={{ width: '100%' }}>
            <div className="form-element">
                <label>Publish Type</label>
                <div className="steps-tabs">
                    <div className={publishType === 'new' ? "steps-tabs-button-active" : "steps-tabs-button"}>
                        <input type="checkbox" style={{ display: 'none' }}
                            name="new" onChange={handleChange}
                            id="publish-rpa-check" checked={publishType.new} />
                        <label style={{
                            cursor: 'pointer',
                            width: "100%",
                            textAlign: "center"
                        }} htmlFor="publish-rpa-check" >
                            <span style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{t("CONTENT.PUBLISH.NEW-BOT")}</span>
                        </label>
                    </div>
                    <div className={publishType === 'update' ? "steps-tabs-button-active" : "steps-tabs-button"}>
                        <input type="checkbox" style={{ display: 'none' }}
                            name="update" onChange={handleChange}
                            id="publish-ipaas-check" checked={publishType.update} />
                        <label style={{
                            cursor: 'pointer',
                            width: "100%",
                            textAlign: "center"
                        }}
                            htmlFor="publish-ipaas-check"
                        >
                            <span style={{ fontSize: '1.2em', fontWeight: 'bold' }}>{t("CONTENT.PUBLISH.UPDATE-BOT")}</span>
                        </label>
                    </div>
                </div>
                {
                    publishType === 'update' && (
                        <>
                            <div className="form-element">
                                <label>Choose Bot</label>
                                <SelectInput value={selectedBotId} param="name" onChange={handleSelect} data={bots} name="name" valueKey="id" />
                                <div><small>{t("CONTENT.PUBLISH.SELECT-ACTION-YOU-WANT-TO-UPDATE-FROM-LOCAL")}</small></div>

                            </div>
                            {
                                selectedBotId && (
                                    <div className="form-element">
                                        <label>Latest Version</label>
                                        <div style={{ marginTop: '5px' }}> {bots.find(x => x.id === selectedBotId)?.latest_version}</div>
                                    </div>

                                )
                            }
                        </>
                    )
                }
            </div>


        </div >
    );
};


export default StepSelectPublishType;
